import { render, staticRenderFns } from "./eventRecord.vue?vue&type=template&id=5f67db76&scoped=true"
import script from "./eventRecord.vue?vue&type=script&lang=js"
export * from "./eventRecord.vue?vue&type=script&lang=js"
import style0 from "./eventRecord.vue?vue&type=style&index=0&id=5f67db76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f67db76",
  null
  
)

export default component.exports